export default __webpack_public_path__ + "static/media/CAT MUJERES.7e175a91.svg";